var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.title
        ? _c("div", {
            staticClass: "weui-cells__title",
            style: _vm.cleanStyle({
              color: _vm.titleColor
            }),
            domProps: { innerHTML: _vm._s(_vm.title) }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("title"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "weui-cells",
          class: {
            "vux-no-group-title": !_vm.title
          },
          style: _vm.cleanStyle({
            marginTop:
              typeof _vm.gutter === "number" ? _vm.gutter + "px" : _vm.gutter
          })
        },
        [_vm._t("after-title"), _vm._v(" "), _vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.footerTitle
        ? _c("div", {
            staticClass: "weui-cells__title vux-group-footer-title",
            style: _vm.cleanStyle({
              color: _vm.footerTitleColor
            }),
            domProps: { innerHTML: _vm._s(_vm.footerTitle) }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c0e995e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c0e995e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group/index.vue
// module id = null
// module chunks = 